import { configurationMenuUrl } from "@saleor/configuration";
import useBulkActions from "@saleor/hooks/useBulkActions";
import useListSettings from "@saleor/hooks/useListSettings";
import useNavigator from "@saleor/hooks/useNavigator";
import usePaginator, {
  createPaginationState
} from "@saleor/hooks/usePaginator";
import { maybe } from "@saleor/misc";
import { ListViews } from "@saleor/types";
import React from "react";

import SiteLanguageListPage from "../../components/SiteLanguageListPage";
import { useSiteLanguageListQuery } from "../../queries";
import { SiteLanguageListUrlQueryParams, siteLanguageUrl } from "../../urls";

interface SiteLanguageListProps {
  params: SiteLanguageListUrlQueryParams;
}

export const SiteLanguageList: React.FC<SiteLanguageListProps> = ({
  params
}) => {
  const navigate = useNavigator();
  const paginate = usePaginator();
  const { isSelected, listElements, toggle, toggleAll } = useBulkActions();
  // params.ids
  const { updateListSettings, settings } = useListSettings(
    ListViews.PAGES_LIST
  );

  const paginationState = createPaginationState(settings.rowNumber, params);
  const queryVariables = React.useMemo(
    () => ({
      ...paginationState
    }),
    [params]
  );
  const { data, loading } = useSiteLanguageListQuery({
    displayLoader: true,
    variables: queryVariables
  });

  const { loadNextPage, loadPreviousPage, pageInfo } = paginate(
    maybe(() => data.siteLanguages.pageInfo),
    paginationState,
    params
  );

  return (
    <>
      <SiteLanguageListPage
        disabled={loading}
        settings={settings}
        siteLanguages={maybe(() =>
          data.siteLanguages.edges.map(edge => edge.node)
        )}
        pageInfo={pageInfo}
        onAdd={undefined}
        onBack={() => navigate(configurationMenuUrl)}
        onNextPage={loadNextPage}
        onPreviousPage={loadPreviousPage}
        onUpdateListSettings={updateListSettings}
        onRowClick={id => () => navigate(siteLanguageUrl(id))}
        isChecked={isSelected}
        selected={listElements.length}
        toggle={toggle}
        toggleAll={toggleAll}
        toolbar={undefined}
      />
    </>
  );
};

export default SiteLanguageList;
